import React from 'react'
import HelpHtml from '../help/HelpHtml'
import { connect } from 'react-redux'
import { Glyphicon } from 'react-bootstrap'
import * as API from 'modules/app/API'

class Help extends React.Component {
	constructor(props) {
		super(props);

		this.viewer = null;
		this.state = {};
	}

	getHelp = (helpKey) => {
		API.App.get('/query/getHelp', { helpKey },
			{
				success: (sr) => {
					this.setState(sr.data);
				}
			});
	}

	onClick = () => {
		if (this.state.helpType !== 'URL') {
			this.viewer.display()
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.helpKey === nextProps.helpKey)
			return;

		this.getHelp(nextProps.helpKey);
	}

	componentWillMount = () => {
		this.getHelp();
	}

	render() {
		// No help?
		if (!this.state.helpType)
			return null;

		return (
			<React.Fragment>
				<a onClick={this.onClick} style={{ cursor: "pointer" }}>
					<Glyphicon glyph="question-sign" /><span>Help</span>
				</a>
				<HelpHtml
					helpKey={this.state.helpKey}
					content={this.state.helpContent}
					ref={(r) => { this.viewer = r }} ></HelpHtml>
			</React.Fragment>);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		helpKey: state.Help.helpKey
	}
}

const HelpContainer = connect(
	mapStateToProps
)(Help)

export default HelpContainer;



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/help/Help.js